export const messages = {
  HISName: 'نام بیمارستان',
  hisType: 'نوع HIS',
  HISUrl: 'آدرس HIS(URL) ',
  connectionUsername: 'نام کاربری اتصال',
  connectionPassword: 'رمز اتصال',
  viewName: 'اسم view در دیتابیس',
  dayOffset: 'ارسال پیامک پس از چه تعداد روز از ترخیص بیمار',
  validDate: ' نمایش آخرین تاریخ ارسال پیامک',
  smsUrl: 'آدرس پیامک (URL)',
  smsUrlExp: '(توضیح:شناسه یکتای کاربر به پایان این آدرس اضافه خواهد شد.)',
  smsMessage: 'متن پیامک',
  HISHeader: 'تنظیم اطلاعات HIS جهت ارسال پیامک رضایت سنجی',
  lastUpdate: 'تاریخ ترخیص اخرین پیامک ارسال شده ',
  includeDeleted: 'به همراه حذف شده ها',
  test: 'بررسی اتصال',
  connectionUrlPlaceholder: 'URL باید با jdbc:sqlserver شروع شود.',
  connected: 'با موفقیت متصل شده اید.',
  failedToConnect: 'اتصال شما با شکست مواجه شده است.',
  HISPatientPeriods: 'بازه انتخابی',
  findPatient: 'جست و جوی تعداد بیماران',
  PatientCount: 'تعداد بیماران در بازه زمانی انتخابی  : ',
  smsStatics: 'آمار ارسال پیامک',
  create: 'ایجاد',
  update: 'بروزرسانی',
  deleted: 'حذف شده',
  enabled: 'فعال',
  samplePhoneTest: 'تست ارسال پیامک',
  samplePhonenumber: 'شماره تست',
  testSamplePhoneNumber: 'بررسی تست شماره تلفن',
  successfulySent: 'با موفقیت پیامک ارسال شد',
  failedToSend: 'مشکلی در ارسال پیامک رخ داده است',
  testphoneExp:
    'برای یک بیمار به صورت آزمایشی پیامک ارسال میشود ولی به جای شماره تلفن او به شماره زیر پیامک ارسال میگردد.',
  newHISAddedSuccessfully: 'مشخصات HIS جدید با موفقیت افزوده شد.',
  newHISFailed: 'در ذخیره سازی HIS جدید با مشکل مواجه شده است.',
};
